const HomePage = () => import("./pages/HomePage.vue");

export const TCRoutes = [
  {
    path: "/tc-survey",
    component: HomePage
  },
  {
    path: "/tc-survey/:category",
    component: HomePage
  }
];
